import _ from 'lodash'
import { TransitionDropList } from '@vzmi/shp_shared_compo'
import { FormValueSelector } from '../../../Common/forms'
import withProposalListingFormUploadFiles from '../../../Proposal/Common/HOC/withProposalListingFormUploadFiles'
import ImageFunctionTable from '../../../Proposal/UpdateListing/ImageFunctionTable/ImageFunctionTable'
import StatusPrefixBlock from '../../Common/PrefixBlock/Status'
import ExtraModelPrefixBlock from '../../Common/PrefixBlock/ExtraModel'
import DuplicatedPrefixBlock, {
  getDuplicatedSkuInSpecsList
} from '../../Common/PrefixBlock/Duplicated'
import ListingCollapseBlock from '../../Common/ListingCollapseBlock'

const {
  TransitionDropListContainer,
  TransitionDropItem
} = TransitionDropList

const ListingImageRow = props => {
  const {
    index,
    listing,
    duplicatedMap,
    proposalType,
    batchResult,
    readOnly,
    onRemove,
    isOverviewPage,
    onLayoutChange,
    defaultExpanded
  } = props
  const {
    id: listingId,
    models = [],
    isNoModelsListing,
    shareMediaBetweenModels
  } = listing
  const modelSpecHeader = _.get(models, '[0].spec.name', '')
  const itemSpecHeader = _.get(models, '[0].items[0].spec.name', '')
  const listingFieldPrefix = `listings[${index}]`
  const duplicatedList = _.get(duplicatedMap, listingId, [])
  const isDuplicatedListExist = (
    !_.isEmpty(duplicatedList) &&
    // 如果發現有共用商品但 listings 是空的
    // 代表除了此賣場外沒有跟其他賣場有重複的 sku
    // 也就是說同一個雙層屬性賣場內不同商品的第二層屬性有一樣的屬性
    // 這是從 ERP 調整沒經過驗證，預期外的資料，會從 DuplicatedPrefixBlock 另外判斷
    !_.isEmpty(_.get(duplicatedList, '0.listings'))
  )
  const duplicatedSkuInSpecsList = getDuplicatedSkuInSpecsList(models)
  const isDuplicatedSkuInSpecsListExist = !_.isEmpty(duplicatedSkuInSpecsList)

  return (
    <>
      {/* 更新成功失敗區塊 */}
      <StatusPrefixBlock
        proposalType={proposalType}
        listing={listing}
        batchResult={batchResult}
        isOverviewPage={isOverviewPage}
      />
      {/* 賣場有贈品、加價購商品區塊 */}
      <ExtraModelPrefixBlock
        proposalType={proposalType}
        listing={listing}
      />
      {/* 賣場含有共用商品區塊 */}
      <DuplicatedPrefixBlock
        proposalType={proposalType}
        duplicatedMap={duplicatedMap}
        listing={listing}
      />
      {/* 賣場區塊 */}
      <ListingCollapseBlock
        batchResult={batchResult}
        proposalType={proposalType}
        onRemove={onRemove}
        onCollapseChange={onLayoutChange()}
        listing={listing}
        readOnly={readOnly}
        defaultExpanded={defaultExpanded}
      >
        {/* 修改圖片功能 */}
        <ImageFunctionTable
          readOnly={readOnly || isDuplicatedListExist || isDuplicatedSkuInSpecsListExist}
          models={models}
          isNoModelsListing={isNoModelsListing}
          modelsFieldName={`${listingFieldPrefix}.models`}
          shareImageFieldName={`${listingFieldPrefix}.shareMediaBetweenModels`}
          syncImageFieldName={`${listingFieldPrefix}.syncProductImages`}
          modelSpecHeader={modelSpecHeader}
          itemSpecHeader={itemSpecHeader}
          shareMediaBetweenModels={shareMediaBetweenModels}
          defaultShowUploader={false}
          syncProductImages
          hasDistinctSizesUploader
        />
      </ListingCollapseBlock>
    </>
  )
}

const ListingImageRows = props => {
  const {
    readOnly,
    onRemove,
    batchResult,
    duplicatedMap = {},
    isOverviewPage,
    proposalType,
    defaultExpanded = true
  } = props

  return (
    <FormValueSelector
      // redux proposal form listings
      selector={select => ({
        listings: select('listings')
      })}
    >
      {({ listings = [] }) => {
        return (
          // 刪除賣場轉場容器
          <TransitionDropListContainer>
            {listings.map((listing, index) => {
              const {
                id: listingId
              } = listing

              return (
                // 刪除賣場轉場項目
                <TransitionDropItem
                  key={listingId}
                  id={listingId}
                >
                  {onLayoutChange => {
                    return (
                      <ListingImageRow
                        listing={listing}
                        index={index}
                        duplicatedMap={duplicatedMap}
                        proposalType={proposalType}
                        batchResult={batchResult}
                        readOnly={readOnly}
                        onRemove={onRemove}
                        isOverviewPage={isOverviewPage}
                        onLayoutChange={onLayoutChange}
                        defaultExpanded={defaultExpanded}
                      />
                    )
                  }}
                </TransitionDropItem>
              )
            })}
          </TransitionDropListContainer>
        )
      }}
    </FormValueSelector>
  )
}

export default withProposalListingFormUploadFiles(ListingImageRows)
